import styled from "@emotion/native"
import { Platform, useWindowDimensions } from "react-native"
import { Slider } from "./Slider"
import { Text } from "./Typography"

const DESKTOP_MIN_WIDTH = 768

type PayCTAProps = {
  onSlideRight: () => Promise<void>
  title?: string
  disabled?: boolean
  testID?: string
}

export function PayCTA({ onSlideRight, title = "Slide to pay", disabled, testID }: PayCTAProps) {
  const { width } = useWindowDimensions()
  const isDesktopWeb = Platform.OS === "web" && width >= DESKTOP_MIN_WIDTH

  if (!isDesktopWeb) {
    return <Slider onSlideRight={onSlideRight} title={title} disabled={disabled} testID={testID} />
  }

  const label = toButtonLabel(title)

  return (
    <DesktopButton
      testID={testID}
      accessibilityRole="button"
      accessibilityLabel={label}
      accessibilityState={{ disabled: !!disabled }}
      disabled={disabled}
      $isDisabled={!!disabled}
      onPress={() => {
        if (!disabled) {
          void onSlideRight()
        }
      }}
    >
      <Text
        fontFamily="IBMPlexSans-Medium"
        fontSize={20}
        lineHeight={26}
        color="white"
        align="center"
      >
        {label}
      </Text>
    </DesktopButton>
  )
}

function toButtonLabel(title: string) {
  const prefix = "Slide to "
  if (!title.startsWith(prefix)) {
    return title
  }

  const action = title.slice(prefix.length)
  return action.charAt(0).toUpperCase() + action.slice(1)
}

const DesktopButton = styled.Pressable<{ $isDisabled: boolean }>`
  width: 100%;
  max-width: 500px;
  align-self: center;
  height: 66px;
  background-color: #3b58e3;
  border-radius: 100px;
  align-items: center;
  justify-content: center;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
  cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "pointer")};
`
